import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const EyeStateFalseIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "EyeStateFalseIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M12.5002 15.305C10.6778 15.305 9.19524 13.8224 9.19524 12.0005C9.19524 11.1144 9.54156 10.2818 10.1707 9.65663C10.4689 9.35993 10.9497 9.36191 11.2469 9.65861L14.8416 13.2538C15.1388 13.5505 15.1393 14.0328 14.8426 14.3305C14.2169 14.9586 13.3849 15.305 12.5002 15.305ZM10.8256 11.3932C10.7557 11.5847 10.7195 11.7901 10.7195 12.0005C10.7195 12.9819 11.5183 13.7807 12.5002 13.7807C12.7106 13.7807 12.915 13.744 13.107 13.6746L10.8256 11.3932Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.5002 19.1899C5.83769 19.1899 2.70095 12.6019 2.57095 12.322C2.47618 12.1176 2.47618 11.8814 2.57195 11.678C2.63347 11.546 4.11403 8.43208 7.16792 6.43652C7.46959 6.23805 7.8685 6.28072 8.12353 6.53575L17.9645 16.3767C18.1267 16.5384 18.2071 16.7657 18.1838 16.9939C18.1604 17.2221 18.0354 17.4276 17.8434 17.5526C16.1857 18.6392 14.3876 19.1899 12.5002 19.1899ZM4.12146 12.0005C4.80914 13.2459 7.59609 17.6657 12.5002 17.6657C13.7823 17.6657 15.0197 17.3601 16.1892 16.7568L7.49736 8.06493C5.65412 9.44328 4.52583 11.2692 4.12146 12.0005Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.7998 15.6086C19.6211 15.6086 19.441 15.5461 19.2962 15.4181C18.9806 15.1402 18.9503 14.658 19.2287 14.3424C20.0717 13.3868 20.6224 12.4699 20.8789 12.0015C20.1932 10.7581 17.4058 6.33431 12.5002 6.33431C11.8209 6.33431 11.1476 6.41965 10.4986 6.58735C10.0888 6.68758 9.6755 6.44645 9.57032 6.03959C9.46513 5.63174 9.70975 5.21695 10.1176 5.11077C10.8906 4.91131 11.6924 4.8101 12.5002 4.8101C19.1622 4.8101 22.2989 11.3992 22.4289 11.68C22.5237 11.8834 22.5237 12.1176 22.4289 12.322C22.4011 12.3816 21.7303 13.8095 20.3718 15.3506C20.2215 15.5213 20.0111 15.6086 19.7998 15.6086Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.7284 22C21.531 22 21.3336 21.9247 21.1829 21.774L2.7265 3.31706C2.42511 3.01567 2.42511 2.52743 2.7265 2.22604C3.02789 1.92465 3.51613 1.92465 3.81752 2.22604L22.2739 20.6829C22.5753 20.9843 22.5753 21.4726 22.2739 21.774C22.1232 21.9246 21.9258 22 21.7284 22Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default EyeStateFalseIcon;
